export default () => {
    if (typeof window === 'undefined') return false;
    return navigator && navigator.userAgent.toLowerCase().indexOf('firefox') > -1 || false;
}

